<template>
        <section class="page-section bg-light" id="contact">
            <div class="container">
                <div class="text-center">
                    <h2 class="section-heading text-uppercase">Kontakt</h2>
                    <h3 class="section-subheading text-muted">Gerne nehmen wir Ihre Reservierungen entgegen.</h3>
                </div>
                 <div class="row">
                    <div class="col-lg-4 mr-auto text-center">
                        <i class="fas fa-map-marked-alt fa-3x mb-3 text-muted"></i>
                        <div>Hauptstrasse 3, 4462 Rickenbach BL</div>
                    </div>
                    <div class="col-lg-4 mr-auto text-center">
                        <i class="fas fa-phone fa-3x mb-3 text-muted"></i>
                        <div>061 981 54 36</div>
                    </div>
                    <div class="col-lg-4 mr-auto text-center">
                        <i class="fas fa-envelope fa-3x mb-3 text-muted"></i>
                        <a href="#" class="cryptedmail" data-name="barriere" data-domain="barriere-rickenbach" data-tld="ch" onclick="window.location.href = 'mailto:' + this.dataset.name + '@' + this.dataset.domain + '.' + this.dataset.tld; return false;"></a>
                    </div>
                </div>

                <form id="contactForm" name="sentMessage" v-on:submit.prevent="checkForm" novalidate="true">
                    <div class="row align-items-stretch mb-5">
                        <div class="col-md-6">
                            <div class="form-group">
                                <input class="form-control" v-model="name" id="name" type="text" placeholder="Name *" required="required" data-validation-required-message="Please enter your name." />
                                <p v-if="error_name.length" class="help-block text-danger">
                                  <ul>
                                    <li v-for="(error, key) in error_name" :key=key>{{ error }}</li>
                                  </ul>
                                </p>
                            </div>
                            <div class="form-group">
                                <input class="form-control" v-model="email" id="email" type="email" placeholder="E-Mail-Adresse *" required="required" data-validation-required-message="Please enter your email address." />
                                <p v-if="error_email.length" class="help-block text-danger">
                                  <ul>
                                    <li v-for="(error, key) in error_email" :key=key>{{ error }}</li>
                                  </ul>
                                </p>
                            </div>
                            <div class="form-group mb-md-0">
                                <input class="form-control" v-model="phone" id="phone" type="tel" placeholder="Telefonnummer *" required="required" data-validation-required-message="Please enter your phone number." />
                                <p v-if="error_phone.length" class="help-block text-danger">
                                  <ul>
                                    <li v-for="(error, key) in error_phone" :key=key>{{ error }}</li>
                                  </ul>
                                </p>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group form-group-textarea mb-md-0">
                                <textarea class="form-control" v-model="message" id="message" placeholder="Ihre Mitteilung *" required="required" data-validation-required-message="Please enter a message."></textarea>
                                <p v-if="error_message.length" class="help-block text-danger">
                                  <ul>
                                    <li v-for="(error, key) in error_message" :key=key>{{ error }}</li>
                                  </ul>
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="text-center">
                        <div class="g-recaptcha" :data-sitekey="rcapt_sig_key" data-callback="enableBtn"></div>
                    </div> 
                    <div class="text-center">
                        <div v-show='isHidden'>
                          <div v-if="errors.length" class='alert alert-danger'>
                            <button v-on:click="isHidden = false" type='button' class='close' aria-hidden='true'>&times;</button>
                            <strong v-for="(error, key) in errors" :key=key>
                            {{ error }}
                            </strong>
                          </div>
                          <div v-if="successes.length" class='alert alert-success'>
                            <button v-on:click="isHidden = false" type='button' class='close' aria-hidden='true'>&times;</button>
                            <strong v-for="(success, key) in successes" :key=key>
                            {{ success }}
                            </strong>
                          </div>
                        </div>
                        <button  class="btn btn-primary btn-xl text-uppercase" id="sendMessageButton" type="submit" disabled>Absenden</button>
                    </div>
                </form>
            </div>
        </section>
</template>

<script src='https://www.google.com/recaptcha/api.js'></script> 

<script>
export default {
    data(){
      return{
          rcapt_sig_key: this.$appConfig.g_data_sitekey, //"6LfZw_0UAAAAAMMKC9t3WQnhW326GL68SsTeh3TE",
          rcapt_id: 0,

          isHidden: true,
          successes: [],
          errors: [],

          name: null,
          email: null,
          phone: null,
          message: null,

          error_name: [],
          error_email: [],
          error_phone: [],
          error_message: [],
      }
    },
    methods: {
    checkForm: function (event) {
      this.errors = [];
      this.successes = [];
      this.error_name = [];
      this.error_email = [];
      this.error_phone = [];
      this.error_message = [];

      if(!this.name){
        this.error_name.push('Bitte gib deinen Namen ein.');
      } 
      if (!this.email) {
        this.error_email.push('Bitte gib deine Email Adresse ein.');
      } else if (!this.validEmail(this.email)) {
        this.error_email.push('Bitte gib eine gültige Email Adresse ein.');
      }
      if (!this.phone){
        this.error_phone.push('Bitte gib eine Telefonnumer ein.');
      }
      if (!this.message) {
        this.error_message.push('Bitte gib eine Nachricht ein.');
      }

      if (!this.error_name.length && !this.error_email.length && !this.error_phone.length && !this.error_message.length) {
        let recaptcha_response_value = event.target['g-recaptcha-response'].value;
        var data = {
          name: this.name,
          phone: this.phone,
          email: this.email,
          message: this.message,
          g_recaptcha_response: recaptcha_response_value,
        };
        this.sendContactForm(data)
      } 
    },

    sendContactForm: function(data){
        const CONTACT_API_ENDPOINT = this.$appConfig.post_api.conform
        fetch(CONTACT_API_ENDPOINT, {
          method: 'post',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(data)
        })
        .then((response) => {
          this.isHidden = true
          this.name = ""
          this.email = ""
          this.phone = ""
          this.message = ""
          //grecaptcha.reset();
          const resdata = response.data
          document.getElementById("sendMessageButton").disabled = true;
          this.successes.push('Danke, Wir werden uns in kürze bei dir melden.');
          grecaptcha.reset();

        })
        .catch(() => {
          this.isHidden = true
          this.errors.push('Sorry, es scheint, dass mein Mailserver nicht antwortet. Bitte versuche es später noch einmal!');
        });
    },

    validEmail: function (email) {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
  }
}
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
.mb-5,
.my-5 {
  margin-top: 5rem !important;
  margin-bottom: 3rem !important;
}
.text-center {
  text-align: center !important;
  padding-bottom: 1rem !important;
}
.col-md-6 {
    flex: 0 0 50%;
    max-width: 50%;
    text-align: left;
}
.cryptedmail:after {
  content: attr(data-name) "@" attr(data-domain) "." attr(data-tld); 
  display: block !important;
}
a {
  color: #2c3e50;
}
/* 6c757d */
</style>        